import { render, staticRenderFns } from "./AdminPanel.vue?vue&type=template&id=35ec6cfc&scoped=true&"
import script from "./AdminPanel.vue?vue&type=script&lang=js&"
export * from "./AdminPanel.vue?vue&type=script&lang=js&"
import style0 from "./AdminPanel.vue?vue&type=style&index=0&id=35ec6cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ec6cfc",
  null
  
)

component.options.__file = "AdminPanel.vue"
export default component.exports